import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {DateTimeService} from "../../../services/date-time.service";
import {SubStatusesService} from "../sub-statuses/sub-statuses.service";
import {DatePipe} from "@angular/common";
import {FormControl} from "@angular/forms";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ConfirmationModalComponent} from "../../confirmation-modal/confirmation-modal.component";

@Component({
    selector: 'sub-status-timepicker',
    templateUrl: './sub-status-timepicker.component.html',
    styleUrls: ['./sub-status-timepicker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubStatusTimepickerComponent implements OnInit {
  @Input() substatusDate: any;
  @Input() substatus: any;
  @Input() subsequence: any;
  @Input() project_status_id: number;

  @Output() changeSubstatusDate = new EventEmitter<any>

  constructor(private dateTimeService: DateTimeService, public substatusService: SubStatusesService, public datePipe: DatePipe,  public dialog: MatDialog) {
  }
  public formattedTime: string;
  public timezones: Array<any> = [];
  public selectedTimezone: any;
  public timeControl: FormControl;


  ngOnInit() {
    this.timezones = this.dateTimeService.timezones;
    this.selectedTimezone = this.timezones.filter((tz) => tz.abbr == 'EST')[0]
    this.timeControl = new FormControl()
    if(this.substatusDate?.timezone?.length){
      this.selectedTimezone = this.timezones.filter((tz) => tz.tz == this.substatusDate.timezone)[0]
    }
    if(this.substatusDate?.utc_time?.length && this.substatusDate?.date?.length){
      let date = new Date(this.substatusDate.date + " " + this.substatusDate.utc_time + " " + "UTC")
      let isDST = this.dateTimeService.isDST(date)
      this.timeControl.setValue(this.datePipe.transform(date, 'HH:mm:ss', isDST ? this.selectedTimezone.dstabbr : this.selectedTimezone.abbr))
    }

  }

  onChange(e?:Event){
    this.substatusDate.timezone = this.selectedTimezone.tz
    if(e){
      this.selectedTimezone = this.timezones.find((tz) => tz.tz == e)
      this.substatusDate.timezone = this.selectedTimezone.tz;
    }
    if(this.timeControl.value.length !== 0){
      let time = this.timeControl.value;
      let date = this.datePipe.transform(Date.now(), 'yyyy-MM-dd')
      let dateTime = new Date(date + " " + time);
      this.substatusDate.time = this.dateTimeService.convertTimezoneToUTC(dateTime, this.selectedTimezone.tz)
    }
    this.substatusService.queueProjectSubstatusDateUpdate(this.substatusDate)
    this.changeSubstatusDate.emit(this.substatusDate)
  }
  deleteDateConfirmation() {
    if (this.substatusDate.id) {
      const ref: MatDialogRef<ConfirmationModalComponent> = this.dialog.open(
        ConfirmationModalComponent,
        {
          width: '600px',
          height: '380px',
          data: {
            modalTitle: 'Delete Pipeline Milestone Date',
            actionMessage:
              'Are you sure you want to delete the Pipeline Milestone Date?',
            modalInformation: [
              {
                title: 'Subsequence',
                info: this.subsequence.name,
              },
              {
                title: 'Substatus',
                info: this.substatus.name,
              },
              {
                title: 'Target',
                info: this.substatusDate.target ? 'Yes' : 'No',
              },
              {
                title: 'Date',
                info: this.substatusDate.date!==null ? this.datePipe.transform(this.substatusDate.date, 'MM/dd/yyyy') : '-',
              },
            ],
          },
          backdropClass: 'confirmDialogComponent',
          hasBackdrop: true,
        }
      );
      ref.afterClosed().subscribe((data: any) => {
        if (data?.clicked === 'Ok') {
          let id = this.substatusDate.id;
          this.substatusDate = this.substatusService.generateDummyDate({subsequence_id: this.subsequence.id, substatus_id: this.substatus.id, project_status_id: this.project_status_id});
          this.substatusService.deleteProjectSubstatusDates(
            id,
            this.substatusDate.subsequence_id,
            this.substatusDate.substatus_id
          );
        }
      });
    } else {
      this.substatusService.deleteProjectSubstatusDates(
        this.substatusDate.id,
        this.substatusDate.subsequence_id,
        this.substatusDate.substatus_id
      );
      this.substatusDate = this.substatusService.generateDummyDate({subsequence_id: this.subsequence.id, substatus_id: this.substatus.id, project_status_id: this.project_status_id});
    }
  }

}
